import EyeButton from '@/components/EyeButton.vue'
import { markRaw } from 'vue'
// import { getTradeUrl } from '@/utils'
import type { SwapAlertResponse } from '@/services/alerts-v2-service/types'
import { getSeverityByVol24 } from './swapColumns'
import { getTradeUrl } from '@/utils'
import type { TableColumn } from '@/components/alerts/types'
import { useRouter } from 'vue-router'

export const getSpotSwapTableColumns = (): TableColumn[] => {
  const router = useRouter()
  return [
    {
      field: 'symbol.name',
      header: 'table.asset',
      skeletonWidth: '70px',
      width: '120px',
      class: 'text-left text-sm',
      dynamic: true,
      inner: 'a',
      innerPropsGenerator: (v: object) => {
        const data = v as SwapAlertResponse
        const asset = data.symbol.name.split('/')[0] as string
        const href = router.resolve({
          name: 'eye-all-asset',
          params: {
            asset: asset,
          },
        }).fullPath
        return {
          target: '_blank',
          href: href,
          class: 'pit hover',
        }
      },
    },

    {
      field: 'spread',
      width: '85px',
      header: 'table.spread',
      class: 'text-center',
      sortable: true,
      dynamic: true,
      inner: 'span',
      innerPropsGenerator: (v: object) => {
        const data = v as SwapAlertResponse
        const myClass = data.spread && data.spread > 0 ? 'success' : 'error'
        return {
          class: `pit digit ${myClass}`,
        }
      },
    },
    {
      field: 'ex_buy.name',
      width: '110px',
      header: 'table.exBuy',
      class: 'text-center xl:text-right font-bold',
      dynamic: true,
      inner: 'a',
      innerPropsGenerator: (v: object) => {
        const data = v as SwapAlertResponse
        const asset = data.symbol.name.split('/')[0] as string
        const href = getTradeUrl(data.ex_buy.name, asset, false)
        return {
          target: '_blank',
          href: href,
          class: 'pit success hover',
        }
      },
    },
    {
      field: 'vol24h_buy',
      width: '105px',
      header: 'table.vol24h',
      class: 'hidden xl:table-cell text-center',
      dynamic: true,
      inner: 'span',
      innerPropsGenerator: (v: object) => {
        const data = v as SwapAlertResponse
        const myClass = getSeverityByVol24(data.vol24h_buy)
        return {
          class: `pit digit ${myClass}`,
        }
      },
    },
    {
      field: 'price_buy',
      width: '115px',
      header: 'table.price',
      class: 'hidden xl:table-cell text-left',
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    {
      field: 'ex_sell.name',
      width: '110px',
      header: 'table.exShort',
      class: 'text-center xl:text-right font-bold',
      dynamic: true,
      inner: 'a',
      innerPropsGenerator: (v: object) => {
        const data = v as SwapAlertResponse
        const asset = data.symbol.name.split('/')[0] as string
        const href = getTradeUrl(data.ex_sell.name, asset, true)
        return {
          target: '_blank',
          href: href,
          class: 'pit error hover',
        }
      },
    },
    {
      dynamic: true,
      field: 'vol24h_sell',
      width: '105px',
      header: 'table.vol24h',
      class: 'hidden xl:table-cell text-center',
      inner: 'span',
      innerPropsGenerator: (v: object) => {
        const data = v as SwapAlertResponse
        const myClass = getSeverityByVol24(data.vol24h_sell)
        return {
          class: `pit digit ${myClass}`,
        }
      },
    },
    {
      field: 'price_sell',
      width: '115px',
      header: 'table.price',
      class: 'hidden xl:table-cell text-left',
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    {
      field: 'rate_short',
      width: '105px',
      header: 'table.fundingRate',
      class: 'text-right hidden xl:table-cell',
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    {
      field: 'period_short',
      width: '115px',
      header: 'table.fundingPeriod',
      class: 'hidden xl:table-cell text-left',
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    // {
    //   field: 'volume',
    //   header: 'table.volume',
    //   class: 'hidden md:table-cell text-center',
    // },
    {
      field: 'updated_at',
      width: '150px',
      header: 'table.timeAgo',
      class: 'text-center',
      skeletonWidth: '70px',
      sortable: true,
      dynamic: true,
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    {
      dynamic: true,
      field: '',
      header: '',
      width: '50px',
      noPadding: true,
      class: 'text-center collapser-class',
      inner: markRaw(EyeButton),
      innerPropsGenerator: (data: object) => {
        const swapData = data as SwapAlertResponse
        return {
          name: 'eye',
          params: {
            asset: swapData.symbol?.name?.split('/')?.[0]?.toLowerCase() ?? '',
            exBuy: swapData['ex_buy']['name'],
            exSell: swapData['ex_sell']['name'],
            marketType: 'spot-swap',
          },
        }
      },
    },
  ]
}
